import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
// 路由守卫（页面默认加载页面）
import './permission'
// 加密（不可逆）
import md5 from 'js-md5';
import Cookies from 'js-cookie';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from "./lang"; // 引入多语言配置

// 全局发现MD5，this.$md5
Vue.prototype.$md5 = md5;
Vue.prototype.$cookie = Cookies;
// Vue.prototype.$VUE_APP_BASE_API = 'http://localhost:8080'
// Vue.prototype.$VUE_APP_BASE_API = 'http://123.56.118.103:8090/api'
Vue.prototype.$VUE_APP_BASE_API = 'https://innaspindle.com/api'
// Vue.prototype.$VUE_BASE_PDF_URL = 'http://localhost:8080'
// Vue.prototype.$VUE_BASE_PDF_URL = 'http://123.56.118.103:8090/api'
Vue.prototype.$VUE_BASE_PDF_URL = 'https://innaspindle.com/api'
Vue.prototype.$appId = 'wwb9a8f9f8bed76e7e';

Vue.use(ElementUI);


new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')